import { Doc } from 'src/@types/docs';
import { useAuthContext } from 'src/auth/useAuthContext';
import { Roles } from 'src/features/workspace/WorkspaceShareMemberRoleSelectProps';
import { useUserFeatureRole } from 'src/hooks/useUserFeatureRole';

type Props = {
  doc: Doc;
};

export const useDocAllowedAction = ({ doc }: Props) => {
  const { user } = useAuthContext();

  const { role } = useUserFeatureRole<Roles, Doc>({
    feature: doc,
    memberId: user?._id as string,
  });

  if (role === Roles.ADMIN)
    return {
      canDelete: true,
      canDuplicate: true,
      canCreateSubDoc: true,
      canToogleFooter: true,
      canShareDoc: true,
      canEditDoc: true,
    };

  if (role === Roles.VIEWER)
    return {
      canDelete: false,
      canDuplicate: false,
      canCreateSubDoc: false,
      canToogleFooter: false,
      canShareDoc: false,
      canEditDoc: false,
    };

  return {
    canDelete: false,
    canDuplicate: true,
    canCreateSubDoc: true,
    canToogleFooter: false,
    canShareDoc: false,
    canEditDoc: true,
  };
};
